import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'factor',
    loadChildren: () => import('./modules/factor/factor.module').then(m => m.FactorModule)
  },

  {
    path: '',
    loadChildren: () => import('./base-panel/layout/layout.module').then(m => m.LayoutModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
